<script setup lang="ts">
import { OptionsGroupsChild, OptionsGroupsMain } from '~/lib/services/store/catalog/catalog.dtos'

defineProps<{
  optionsGroups?: OptionsGroupsMain[] | OptionsGroupsChild[]
  choiceGroup?: OptionsGroupsMain
}>()

defineEmits<{
  (e: 'close-choice'): void
}>()
</script>

<template>
  <section class="mcd-custom-scrollbar md:max-h-64 md:overflow-y-auto md:px-10">
    <!-- Personalization of optionGroups -->
    <template v-if="optionsGroups">
      <section class="p-4 md:p-0">
        <CustomizingOptionGroup
          v-for="optGM in optionsGroups"
          :key="optGM.identifier"
          :options-group="optGM"
        />
      </section>
    </template>
    <!-- Choice of optGroup.options -->
    <template v-else-if="choiceGroup">
      <section class="mt-2 w-[100vw] md:my-0 md:mb-4 md:w-full">
        <ChoiceGroupOptions :options="choiceGroup.options" @close-choice="$emit('close-choice')" />
      </section>
    </template>
  </section>
</template>
